import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FarmerProfileService } from '~/api/services/farmerProfile'
import { FarmersService } from '~/api/services/farmers/index'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import { FarmersQuery } from '~/QueryHooks/Farmers'
import { useAuth } from '~/routes/components/AuthProvider'
import Show from './Show'
import { handleErrors } from '~/utils/helpers'
import { tradingSlotModules } from '~/Constants'

const FarmerProfile: React.FC = () => {
  const { t } = useTranslation()

  const { systemData: { logged: { roleId }, roles, amountUnit, defaultRowsPerPage, modules } } = useAuth()
  const role = roles.find(role => role.id === roleId)
  const hasAnyTradingModules = Boolean(modules.find(module => !!tradingSlotModules.find(tradingSlotSlug => tradingSlotSlug === module.slug)))

  const [isBusy, setIsBusy] = useState(false)
  const [profileData, setProfileData] = useState(null)
  const [farmerImageSrc, setFarmerImageSrc] = useState(null)
  const [dataFiltered, setDataFiltered] = useState({
    rows: defaultRowsPerPage,
    page: 0
  })

  const tableColumnHeaders = [
    {
      name: t('Supplier No.'),
      key: 'supplierNo'
    },
    {
      name: t('Company name'),
      key: 'companyName'
    },
    {
      name: t('Total amount per year (in {{amountUnit}})', { amountUnit }),
      key: 'amount',
      type: 'number',
      tradingColumn: true
    },
    {
      name: t('Trading amount per year (in {{amountUnit}})', { amountUnit }),
      key: 'tradingAmount',
      type: 'number',
      tradingColumn: true
    }
  ]

  const {
    isLoading: isBusySubFarmers,
    data: subFarmersData,
    refetch: fetchFilteredData,
    isFetching: isFetchingData
  } = FarmersQuery.getFarmerSubFarmers({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  });

  useEffect(() => {
    fetchFilteredData()
  }, [dataFiltered])

  useEffect(() => {
    fetchProfileData()
  }, [])

  async function fetchProfileData() {
    setIsBusy(true)
    try {
      const responseProfile = await FarmerProfileService.getProfileData()
      const fileResponse = await FarmersService.getFarmerFile(responseProfile.data.farmer.id)
      setProfileData(responseProfile.data)
      setFarmerImageSrc(fileResponse.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderTable() {
    const filteredColumns = hasAnyTradingModules ?
      tableColumnHeaders :
      tableColumnHeaders.filter(column => !column.tradingColumn)

    return <TableComponent
      tableColumnHeaders={filteredColumns}
      rows={rows || []}
      total={filtered || 0}
      dataFiltered={dataFiltered}
      animated
      isFetchingData={isFetchingData}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
    />
  }

  const { filtered, rows } = subFarmersData ? subFarmersData : { filtered: 0, rows: [] };

  return <Layout
    title={t('Farmer profile')}
    isBusy={isBusy || isBusySubFarmers}
    segmented
  >
    {profileData && <Show
      role={role.label}
      farmerImageSrc={farmerImageSrc}
      showData={profileData.farmer} />}
    <Layout
      title={t('Sub-farmers')}
      childContainerSize={'auto'}
    >
      {subFarmersData && renderTable()}
    </Layout>
  </Layout>
}
export default FarmerProfile